import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useAppContext } from '../../context';

type SendButtonProps = {
    onClick?: () => void;
    disabled?: boolean;
    children?: React.ReactNode;
};

const SendButton: React.FC<SendButtonProps> = ({ onClick, disabled, children }) => {
    const { setOpenPopUp, setStep, setPopupContent } = useAppContext();
    
    useEffect(() => {
        setStep(1);
    }, [setStep]); // Empty dependency array ensures this runs only on mount

    const handleClick = () => {
        setOpenPopUp(true);
        const verificationHash = localStorage.getItem("verificationHash");
        if (verificationHash) {
            setPopupContent("Dialog");
        } else {
            setPopupContent("Verification");
        }
    
    }

    return (
        <Button
            className='button-send'
            variant="contained"
            fullWidth
            disabled={disabled}
            type="submit"
            onClick={handleClick}
            sx={{
                backgroundColor: "#1C3553",
                borderRadius: "10px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: { xs: "14px", md: "16px" },
                paddingY: { xs: 1.4, md: 1.2 },
                paddingX: { xs: 2, md: 3 },
                height: { xs: "48px", md: "42px" },

                ":hover": {
                    backgroundColor: "#172A42",
                },
            }}
        >
            {children || "გაგრძელება"}
        </Button>

    );
}
export default SendButton;